<template>

    <v-layout row wrap class="mt-5">
      <!-- Paso 1 -->

      <!-- Paso 2 -->
      <v-flex xs9 sm9 md9 lg9 xl9 offset-xs2 v-if="pasosPrueba === 1">
        <p class="headline gray--text" >{{ prueba.section.section_title}}</p>
        <p class="title gray--text"> CURSO: {{ prueba.section.unity.course.cource_title }}</p>
      <v-divider></v-divider>
      </v-flex>

      <v-flex xs2 sm2 md2 lg2 xl2 v-if="pasosPrueba === 1" class="mt-3">
        <p class="text-xs-center">Preguntas</p>
        <v-flex xs6 offset-xs3>
            <v-layout row wrap>
              <v-flex xs6 v-for="(pregunta, index) in prueba.questions" :key="pregunta.id"  class="text-xs-center px-0">
                 <v-btn class="mx-0" outline fab dark small color="secondary" @click="editAnswerSaltarPregunta(index)">{{ index + 1 }}</v-btn>
              </v-flex>
            </v-layout>
             <v-layout column align-center justify-center>
               <v-btn outline  class="margin-0 primary--text mt-3" id="back-naranja"  @click="verCurso()">Terminar </v-btn>
              </v-layout>
        </v-flex>
      </v-flex>
      <v-flex xs9 sm9 md9 lg9 xl9  v-if="pasosPrueba === 1" class="mt-3">
        <template>
          <div>
            <v-alert v-if="estadoRespuesta === 1" outline color="success" icon="check_circle" :value="true">
              ¡Buen Trabajo!
            </v-alert>
            <v-alert v-if="estadoRespuesta === 2" outline color="error" icon="warning" :value="true">
              Error
            </v-alert>
          </div>
        </template>

        <p class="display-1 color-primary">{{ prueba.questions[contadorPregunta].question_text }}</p>
        <!-- sap -->
        <template v-if="prueba.questions[contadorPregunta].type_question_id == 5">
          <v-layout row wrap>
            <v-flex xs6>
              <v-layout row wrap class="bordes">
                <v-flex xs6  class="accent">
                    <p class="subheading text-xs-center mt-3 white--text" >Transacción</p>
                  </v-flex>
                  <v-flex xs6 class="accent">
                    <p class="subheading text-xs-center mt-3 white--text">Código</p>
                </v-flex >
                <v-flex xs6 class="py-0 borde-derecha-abajo " v-for="item in prueba.questions[contadorPregunta].answers" :key="item.id" style="margin-bottom: 0px !important;">
                  <v-text-field
                    name="input-1-3"
                    color="accent"
                    single-line
                    solo
                    v-model="item.response"
                  ></v-text-field>
                </v-flex> 
                  
              </v-layout>
            </v-flex>
            <v-flex xs5 offset-xs1>
              <v-layout row wrap class="bordes">
                <v-flex xs6  class="secondary">
                    <p class="subheading text-xs-center mt-3 white--text" >Nombre</p>
                  </v-flex>
                  <v-flex xs6 class="secondary  ">
                    <p class="subheading text-xs-center mt-3 white--text">Dato</p>
                </v-flex >
                <v-flex xs12 class="py-0 borde-derecha-abajo " v-for="item in encabezado" :key="item.id" style="margin-bottom: 0px !important;">
                  <v-layout row wrap>
                                      <v-flex xs6>
                    <v-text-field
                      name="input-1-3"
                      color="accent"
                      single-line
                      disabled
                      solo
                      v-model="item.codigo"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                      <v-text-field
                      name="input-1-3"
                      color="accent"
                      single-line
                      solo
                      v-model="item.datoM"
                    ></v-text-field>
                  </v-flex>
                  </v-layout>


                </v-flex> 
                  
              </v-layout>
            </v-flex>
          </v-layout>

        </template>


        <template v-if="prueba.questions[contadorPregunta].type_question_id == 1">
          <v-layout row wrap>
            <v-text-field
              name="input-1-3"
              autofocus
              label="Ingrese su respuesta"
              single-line
              solo
              class="mt-5"
              v-model="prueba.questions[contadorPregunta].answers[0].response"
            ></v-text-field>
          </v-layout>
        </template>


        <template v-if="prueba.questions[contadorPregunta].type_question_id == 2" >
          <v-layout row wrap >
            <v-text-field
              name="input-7-1"
              label="Ingrese su respuesta"
              persistent-hint
              multi-line
              autofocus
              solo
              v-model="prueba.questions[contadorPregunta].answers[0].response"
            ></v-text-field>
          </v-layout>
        </template>


        <template v-if="prueba.questions[contadorPregunta].type_question_id == 3">

          <v-layout row wrap>
           <v-radio-group v-model="prueba.questions[contadorPregunta].eleccion" :mandatory="true">
            <p>{{ prueba.questions[contadorPregunta].eleccion }}</p>

            <template v-for="(alternativa,index) in prueba.questions[contadorPregunta].answers"  v-bind:key=""> 
              <v-radio class="color-primary " :label="alternativa.response_option.response_options_test" :value="alternativa.id"></v-radio>
             
            </template>
          </v-radio-group>
              
          </v-layout>
        </template>


        <template v-if="prueba.questions[contadorPregunta].type_question_id == 4">
          <v-layout row wrap>
          <v-flex xs12 v-for="(alternativa,index) in prueba.questions[contadorPregunta].answers" :key="alternativa.id">
            <v-checkbox class="color-primary " :label="alternativa.response_option.response_options_test" v-model="prueba.questions[contadorPregunta].eleccion" :value="alternativa.id"></v-checkbox>
          </v-flex>
          </v-layout>
        </template>


        <v-toolbar  color="  mi-imagen-abajo mt-5">
          <v-toolbar-title class="accent--text">Pregunta {{ contadorPregunta + 1  }} de {{ cantidadPreguntas }}</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-btn v-if="cantidadPreguntas != contadorPregunta+1" class="margin-0 white--text  " id="back-naranja" @click="editAnswer()">siguiente ></v-btn>
          <v-btn v-if="cantidadPreguntas == contadorPregunta+1" class="margin-0 white--text" id="back-naranja"  @click="verCurso()">Finalizar ></v-btn>
        </v-toolbar>


      </v-flex>
      <!-- Paso 3 --> 
      <v-flex xs12 class="panelDerechaLeccion" v-if="pasosPrueba === 2">
        <div>
          <v-tabs v-model="active2" scrollable>
            <v-tabs-bar class="back-naranja" >
              <v-tabs-item
                v-for="tab in tabs"
                :key="tab"
                :href="'#' + tab"
                ripple
                 class="tab-leccion-derecha"
              >
                  <p class="estilo-p">{{ tab }}</p>
              </v-tabs-item>
              <v-tabs-slider color="color-secondary-blue"></v-tabs-slider>
            </v-tabs-bar>
            <v-tabs-items>
              <v-tabs-content
                v-for="tab in tabs"
                :key="tab"
                :id="tab"
              >
                <v-card flat>

                  <!-- Pestaña de LEccion -->

                  <v-flex  class="ml-0"  v-if="tab === 'Resumen'">
                     <p class="text-xs-left display-2 blue-grey--text">Resumen de los resultados de la prueba</p>
                    <v-layout row wrap>
                      <v-flex xs10 sm3 md3 lg3 xl3 >
                        <v-card flat color="color-secondary-blue" class="estilo-p">
                          <v-card-title primary-title>
                            <div>Total Respuestas Correctas</div>
                          </v-card-title>
                          <v-card-actions>
                            <p class="text-xs-center display-1 ">{{ resumen.correctas }} de {{ resumen.totalPreguntas }}</p>
                          </v-card-actions>
                        </v-card>
                      </v-flex>
                                 <v-flex xs10 sm3 md3 lg3 xl3 >
                        <v-card flat color="color-secondary-blue" class="estilo-p">
                          <v-card-title primary-title>
                            <div>Total Respuestas Incorrectas</div>
                          </v-card-title>
                          <v-card-actions>
                            <p class="text-xs-center display-1 ">{{ resumen.incorrectas }} de {{ resumen.totalPreguntas }}</p>
                          </v-card-actions>
                        </v-card>
                      </v-flex>
                                 <v-flex xs10 sm3 md3 lg3 xl3 >
                        <v-card flat color="color-secondary-blue" class="estilo-p">
                          <v-card-title primary-title>
                            <div>Puntaje Obtenido</div>
                          </v-card-title>
                          <v-card-actions>
                            <p class="text-xs-center display-1 ">{{ resumen.puntaje }} puntos</p>
                          </v-card-actions>
                        </v-card>
                      </v-flex>
                      <v-flex xs10 sm3 md3 lg3 xl3 >
                        <v-card flat color="color-secondary-blue" class="estilo-p">
                          <v-card-title primary-title>
                            <div>Inicio de la prueba</div>
                          </v-card-title>
                          <v-card-actions>
                            <p class="text-xs-center display-1 ">22/07/2018</p>
                          </v-card-actions>
                        </v-card>
                      </v-flex>
                      </v-layout>
                    </v-flex>
                  
                  <!-- Pestaña de detalle -->
                  <v-flex class="ml-0 "  v-if="tab === 'Reporte Detallado'">
                      <v-flex xs10 sm10 md10 lg10 xl10 offset-xs2 v-for="(pregunta, index) in prueba.questions" :key="pregunta.id">
                        <div v-if="pregunta.id == correctisimas[index] ">
                          <v-card flat color="success" class="estilo-p">
                          <v-card-title primary-title>
                            {{ pregunta.question_text }}
                              <div style="margin-left:80%" class="">
                                <p>Correcta <i class="material-icons mr-2">
                                check_circle
                                </i>
                              </p>
                                </div>
                          </v-card-title>
                        </v-card>
                        </div>
                        <div v-else>
                          <v-card flat color="red" class="estilo-p">
                          <v-card-title primary-title>
                            {{ pregunta.question_text }}
                              <div style="margin-left:80%">
                                <p>Incorrecta <i class="material-icons">
                                  cancel
                                  </i></p>
                              </div>
                            
                          </v-card-title>
                          <v-card-actions>
                            
                          </v-card-actions>
                        </v-card>
                        </div>
                       
                        <!-- <v-card flat color="color-secondary-blue" class="estilo-p">
                          <v-card-title primary-title>
                            <div>{{ pregunta.question_text }}</div>
                          </v-card-title>
                          <v-card-actions>
                            
                          </v-card-actions>
                        </v-card> -->
                      </v-flex>
                  </v-flex>

                  <!-- Pestaña de links -->
                  <v-flex class="ml-0 "  v-if="tab === 'Historial de Pruebas'">
   

                  </v-flex>

                </v-card>
              </v-tabs-content>
            </v-tabs-items>
          </v-tabs>
        </div>
      </v-flex>

      
    </v-layout>

</template>

<script>
import { testService } from '@/services/Test.service'
import { answerService } from '@/services/Answer.service'
import { summaryService } from '@/services/Summary.service'
import { sectionUserService } from '@/services/SectionsUsers.service'
import { courceService } from '@/services/Cource.service'
import { getAnswerPerUserService } from '@/services/prueba/GetAnswerPerUser.service'
export default {
  data () {
    return {
      idPrueba: 0,
      prueba: {},
      cantidadPreguntas: 0,
      pasosPrueba: 1,
      contadorPregunta: 0,
      ex8: 0,
      estadoRespuesta: 0,
      verResultado: false,
      answer: {},
      currentAnswer: {
        aswerObject: []
      },
      response: {},
      tabs: ['Resumen', 'Reporte Detallado', 'Historial de Pruebas'],
      active2: null,
      resumen: {},
      idCurso: 0,
      curso: {},
      correctisimas: [],
      idQuestion: 0,
      ex5: [],
      encabezado: {}
    }
  },
  methods: {
    loadPrueba () {
      let vm = this
      testService.getById(vm.idPrueba).then(data => {
        vm.prueba = data.body
        vm.cantidadPreguntas = data.body.questions.length
        vm.submitSeccionUsuario()
      })
    },
    loadPruebaUsuario () {
      let vm = this
      getAnswerPerUserService.getById(vm.idPrueba).then(data => {
        if (data.body.tipoHeader === 1) {
          var myJSON = JSON.parse(data.body.header.respuesta_encabezado)
          vm.encabezado = myJSON.filas
        }
        vm.prueba = data.body
        vm.cantidadPreguntas = data.body.questions.length
        vm.submitSeccionUsuario()
      })
    },
    loadCurso () {
      let vm = this
      courceService.getById(vm.idCurso).then(data => {
        vm.curso = data.body
        vm.unidades = data.body.units
        vm.secciones = data.body.units.sections
        vm.competiciones = data.body.competences
        vm.objetivos = data.body.objectives
      })
    },
    resultado () {
      let vm = this
      vm.loadResumen()
      vm.pasosPrueba = 2
    },
    submitAnswer () {
      let vm = this
      vm.answer.test_id = vm.idPrueba
      answerService.save(vm.answer).then(data => {
        vm.prueba = data.body
        vm.pasosPrueba = 1
      }, response => {
      })
    },
    editAnswer () {
      let vm = this
      vm.prueba.questions[vm.contadorPregunta].encabezado = vm.encabezado
      vm.prueba.questions[vm.contadorPregunta].encabezado_id = vm.prueba.header.id
      answerService.update(vm.idPrueba, vm.prueba.questions[vm.contadorPregunta]).then(data => {
        this.$nextTick(function () {
          vm.contadorPregunta++
          this.$nextTick(function () {
            vm.prueba = data.body
          })
        })
      }, response => {
      })
    },
    editAnswerSaltarPregunta (index) {
      let vm = this
      vm.prueba.questions[vm.contadorPregunta].encabezado = vm.encabezado
      vm.prueba.questions[vm.contadorPregunta].encabezado_id = vm.prueba.header.id
      answerService.update(vm.idPrueba, vm.prueba.questions[vm.contadorPregunta]).then(data => {
        vm.prueba = data.body
        vm.contadorPregunta = index
      }, response => {
      })
    },
    loadResumen () {
      let vm = this
      summaryService.getById(vm.answer.id).then(data => {
        vm.resumen = data.body
        vm.submitSeccionUsuario()
      })
    },
    submitSeccionUsuario () {
      let vm = this
      sectionUserService.save(vm.leccion.section.id).then(data => {
      }, response => {
      })
    },
    verCurso () {
      this.$router.push({name: 'showCourse', params: {id: this.curso.id}})
      this.editAnswer()
    }
  },
  mounted () {
    let vm = this
    vm.idPrueba = vm.$route.params.id
    vm.loadPruebaUsuario()
    vm.loadCurso()
  }
}
</script>

<style scoped>

.margin-0{
  margin: 0px;
}

.style-radio{
  margin-top: 15px;
  border-top: 1px solid black;
  border-right: 1px solid black;
  border-bottom: 1px solid black;
  border-left: 1px solid black;
   border-radius: 5px 5px 5px 5px;
   padding: 8px
}

.panelDerechaLeccion{
  background-color: white;
  min-height: 500px;
  margin-top: 10px
}

.estilo-p {
  color: white;
  margin-bottom: 0px
}
#back-naranja{
    background-color: #EB6330;
  }
  .gray--text{
  color: #747474;
}
.back-naranja{
    background-color: #EB6330;
  }
  .color-primary{
  color: #EB6330;
}
.color-gray{
  background-color: #747474;
}
.color-secondary-blue{
  background-color: rgb(47, 185, 235);
  
}

.color-grey-course{
  color: #757575;
}

.bordes{
  border-top: 1px solid #00897b;

  border-bottom: 1px solid #00897b;
  border-left: 1px solid #00897b;
}
.borde-derecha-abajo { 
  border-right: 1px solid #00897b;
  border-bottom: 1px solid #00897b;
 }


</style>




// WEBPACK FOOTER //
// src/components/Prueba/ShowPrueba.vue